import { createTheme, ITheme } from '@fluentui/react/lib/Styling';
import { ContrastColors, CoreColors, DarkColors } from './teams-colors';

export const TeamsThemeDefault: ITheme = createTheme({
  palette: {
    black: CoreColors.appBlack,
    neutralDark: CoreColors.appGray02,
    neutralPrimary: CoreColors.appGray03,
    neutralPrimaryAlt: CoreColors.appGray03,
    neutralSecondary: CoreColors.appGray04,
    neutralTertiary: CoreColors.appGray06,

    neutralTertiaryAlt: CoreColors.appGray08,
    neutralQuaternary: CoreColors.appGray09,
    neutralQuaternaryAlt: CoreColors.appGray09,
    neutralLight: CoreColors.appGray10,
    neutralLighter: CoreColors.appGray12,
    neutralLighterAlt: CoreColors.appGray14,
    white: CoreColors.appWhite,

    // themeDark & ThemeDarkAlt has same color values, themeLighter & themeLighterAlt has same color values
    themeDarker: CoreColors.appBrand02,
    themeDark: CoreColors.appBrand04,
    themeDarkAlt: CoreColors.appBrand04,
    themePrimary: CoreColors.appBrand06,
    themeSecondary: CoreColors.appBrand08,
    themeTertiary: CoreColors.appBrand12,
    themeLight: CoreColors.appBrand14,
    themeLighter: CoreColors.appBrand16,
    themeLighterAlt: CoreColors.appBrand16,

    redDark: CoreColors.appRed
  }
});

export const TeamsThemeDark: ITheme = createTheme({
  palette: {
    black: DarkColors.appBlack,
    neutralDark: DarkColors.appGray02,
    neutralPrimary: DarkColors.appGray03,
    neutralPrimaryAlt: DarkColors.appGray03,
    neutralSecondary: DarkColors.appGray04,
    neutralTertiary: DarkColors.appGray06,

    neutralTertiaryAlt: DarkColors.appGray08,
    neutralQuaternary: DarkColors.appGray09,
    neutralQuaternaryAlt: DarkColors.appGray09,
    neutralLight: DarkColors.appGray10,
    neutralLighter: DarkColors.appGray12,
    neutralLighterAlt: DarkColors.appGray14,
    white: DarkColors.appWhite,

    // themeDark & ThemeDarkAlt has same color values, themeLighter & themeLighterAlt has same color values
    themeDarker: DarkColors.appBrand02,
    themeDark: DarkColors.appBrand04,
    themeDarkAlt: DarkColors.appBrand04,
    themePrimary: DarkColors.appBrand06,
    themeSecondary: DarkColors.appBrand08,
    themeTertiary: DarkColors.appBrand12,
    themeLight: DarkColors.appBrand14,
    themeLighter: DarkColors.appBrand16,
    themeLighterAlt: DarkColors.appBrand16,

    redDark: DarkColors.appRed
  }
});

export const TeamsThemeContrast: ITheme = createTheme({
  palette: {
    black: ContrastColors.appBlack,
    neutralDark: ContrastColors.appGray02,
    neutralPrimary: ContrastColors.appGray03,
    neutralPrimaryAlt: ContrastColors.appGray03,
    neutralSecondary: ContrastColors.appGray04,
    neutralTertiary: ContrastColors.appGray06,

    neutralTertiaryAlt: ContrastColors.appGray08,
    neutralQuaternary: ContrastColors.appGray09,
    neutralQuaternaryAlt: ContrastColors.appGray09,
    neutralLight: ContrastColors.appGray10,
    neutralLighter: ContrastColors.appGray12,
    neutralLighterAlt: ContrastColors.appGray14,
    white: ContrastColors.appWhite,

    // themeDark & ThemeDarkAlt has same color values, themeLighter & themeLighterAlt has same color values
    themeDarker: ContrastColors.appBrand02,
    themeDark: ContrastColors.appBrand04,
    themeDarkAlt: ContrastColors.appBrand04,
    themePrimary: ContrastColors.appBrand06,
    themeSecondary: ContrastColors.appBrand08,
    themeTertiary: ContrastColors.appBrand12,
    themeLight: ContrastColors.appBrand14,
    themeLighter: ContrastColors.appBrand16,
    themeLighterAlt: ContrastColors.appBrand16,

    redDark: ContrastColors.appRed
  }
});
